import { createStyles } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';

const useStyles = createStyles((theme) => ({
  root: {
    backgroundColor: theme.white,
    borderRadius: theme.radius.md,
    padding: theme.other.spacing._32,
    minHeight: 230,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.other.spacing._8,
    textAlign: 'center',
  },
}));

export function SectionStateCard({ title, subtitle }: { title: string; subtitle: string }) {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Text variant="headline-large" c="gray2.9">
        {title}
      </Text>
      <Text variant="body-large" c="gray2.7">
        {subtitle}
      </Text>
    </div>
  );
}
